import { FormControl, FormGroup, Validators } from '@angular/forms';
import { WorkflowConfigType } from '@monorepo/interfaces';
import { DialogConfig, SnackbarConfig, StepperStep } from '@siemens/component-lib';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationDialogData } from '../../shared/interfaces/miscellaneous/ConfirmationDialogData';
import { MessageOperationType } from '../../shared/enums/MessageOperationType.enum';

export class CreateWorkflowOperations {
    public static buildWorkflowDetailsForm(isEditMode: boolean, workflowDetailsId?: string): FormGroup {
        return new FormGroup({
            type: new FormControl<WorkflowConfigType>(
                {
                    value: WorkflowConfigType.COMMERCIAL_WORKFLOW,
                    disabled: true
                },
                Validators.required
            ),
            id: new FormControl<string>(
                {
                    value: workflowDetailsId ? workflowDetailsId : '',
                    disabled: !isEditMode
                },
                Validators.required
            )
        });
    }

    public static initiialWorkflowSteps(): StepperStep[] {
        return [
            {
                label: 'Workflow Setup'
            },
            {
                label: ''
            },
            {
                label: ''
            },
            {
                label: ''
            },
            {
                label: ''
            }
        ];
    }

    public static getSnackbarMessageConfig(
        operation: MessageOperationType,
        title: string,
        description: string,
        translateService: TranslateService
    ): SnackbarConfig {
        return {
            title: translateService.instant(title),
            icon: operation === MessageOperationType.SUCCESS ? 'circle-checkmark' : 'circle-error',
            type: operation,
            description: translateService.instant(description),
            duration: 3000,
            position: 'bottom-right',
            zIndex: 220
        };
    }

    public static getConfirmationDialogData(): DialogConfig<ConfirmationDialogData> {
        return {
            width: '600px',
            data: {
                title: 'workflow.workflow-create.dialog.close.title',
                description: 'workflow.workflow-create.dialog.close.description'
            }
        };
    }
}
